// extracted by mini-css-extract-plugin
export default {"socialMediaContainer":"socialMedia_socialMediaContainer__KfWjt","socialLink":"socialMedia_socialLink__UPviO","socialIcon":"socialMedia_socialIcon__OgxV6"};